import { httpsCallable } from 'firebase/functions';
import { functions } from '../platform/firebase/clients';

export interface SyncAlignedCampaignsResult {
  campaignCount: number;
  expertCount: number;
  syncedAt: string;
  created: number;
  updated: number;
  reactivated: number;
  archived: number;
  /** Experts Aligned flags as reviewers across the synced campaigns. */
  reviewerCount: number;
  /** Reviewer campaigns granted to / revoked from linked Workbench users. */
  reviewerGrantsAdded: number;
  reviewerGrantsRemoved: number;
  reviewerUsersUpdated: number;
}

/**
 * Invokes the admin-only `syncAlignedCampaigns` callable, which upserts every
 * active Aligned campaign into Workbench's `campaigns` collection (marked
 * `alignedSynced: true`), archives ones that have fallen out of Aligned's
 * active set, and brings linked users' reviewer grants in line with Aligned's
 * `campaign_experts.isReviewer` flags.
 */
export async function syncAlignedCampaigns(): Promise<SyncAlignedCampaignsResult> {
  const fn = httpsCallable<unknown, SyncAlignedCampaignsResult>(functions, 'syncAlignedCampaigns');
  const res = await fn();
  return res.data;
}
